import type { LinkProps } from 'react-router-dom';
import type { Props as IconProps } from '../components/elements/Icon';

/**
 * Menu Items Constants
 * 
 * Define menu items for SecondMenu component usage across different pages.
 * Each menu item is a tuple: [MenuName, MenuIconName, url-path]
 */

export type MenuItemType = [string, string, string]; // [MenuName, MenuIconName, url-path]

export type MenuItem = {
	classes?: string[]
	icon?: IconProps
	link?: LinkProps & { state?: unknown }
	onClick?: () => void
	requiresBankId?: boolean
	title: string
	shouldBeLink?: boolean
	url?: string
}

export const menuItems = (
	_hasSmartCards: boolean,
	_hasCreditCards: boolean,
	_hasAtLeastOneBankCard: boolean
): MenuItem[] => [
	{
		classes: [],
		icon: {
			name: 'file-invoice-dollar',
			primaryColor: 'pink500',
			secondaryColor: 'blue400'
		},
		title: 'Mina köp',
		url: 'transaktioner'
	},
	{
		classes: [],
		icon: {
			name: 'credit-card',
			primaryColor: 'red200',
			secondaryColor: 'turquoise500'
		},
		title: 'Mina kort',
		url: 'kort'
	},
	{
		classes: [],
		icon: {
			name: 'user-circle',
			primaryColor: 'red200',
			secondaryColor: 'white'
		},
		title: 'Mitt konto',
		url: 'mitt-konto/dashboard'
	}
]

export const createSideMenu = (_user: {
	name: string
	isCompany: boolean
}): MenuItem[] => [
	{
		classes: ['Button', 'Button--Logout'],
		icon: {
			name: 'sign-out-alt',
			primaryColor: 'red200',
			secondaryColor: 'pink500'
		},
		title: 'Logga ut',
		url: 'loggaut'
	}
]

/**
 * Generate My Account menu items dynamically based on customer's card types
 * 
 * @param hasP - Customer has Smartkort (P type cards)
 * @param hasK - Customer has Tankkort/Företagskort (K type cards)
 * @returns Array of menu items with appropriate invoice/statement label
 */
export const getMyAccountMenuItems = (hasP: boolean, hasK: boolean): MenuItemType[] => {
	const menuItems: MenuItemType[] = [
		['Översikt', 'DashboardIcon', '/mitt-konto/dashboard'],
	];

	// Add invoice/statement menu item based on card types
	if (hasP && hasK) {
		menuItems.push(['Fakturor & Kontobesked', 'ReceiptIcon', '/mitt-konto/fakturor-kontobesked']);
	} else if (hasK) {
		menuItems.push(['Fakturor', 'ReceiptIcon', '/mitt-konto/fakturor-kontobesked']);
	} else if (hasP) {
		menuItems.push(['Kontobesked', 'ReceiptIcon', '/mitt-konto/fakturor-kontobesked']);
	}
	// If neither hasP nor hasK, don't add the menu item

	menuItems.push(
		['Hantera Användare', 'PeopleGroupIcon', '/mitt-konto/hantera-anvandare'],
		['Inställningar', 'SettingsIcon', '/mitt-konto/installningar']
	);

	return menuItems;
};

/**
 * Add more menu item constants as needed for different sections
 * Example:
 * export const ADMIN_MENU_ITEMS: MenuItemType[] = [...];
 * export const PROFILE_MENU_ITEMS: MenuItemType[] = [...];
 */
